import React from "react"
import "./style.css"

interface Props{
    size?: string,
    darkMode?: boolean,
    color?: string,
    width?: string,
    height?: string,
    style?: React.CSSProperties,
    className?: string,
    isMobile?: boolean,
    weve?: boolean
}

const HuLogo : React.FC<Props> = (props : Props) => {
    const style: React.CSSProperties = {
        width: `${props.size ? props.size : "120px"}`,
        height: `${props.size ? props.size : "120px"}`
    }

    const cls1: React.CSSProperties = {
        fill: 'none',
        stroke: `${props.darkMode || props.weve ? '#fff' :'#212121'}`,
        strokeLinecap: 'round',
        strokeMiterlimit: 10,
        strokeWidth: '25.32px'
    }

    const cls2: React.CSSProperties = {
        fill:'#11a2ea'
    }

    const cls3: React.CSSProperties = {
        fill: `${props.darkMode || props.weve ? '#fff' :'#212121'}`
    }

    return (
        <svg id="Layer_3" data-name="Layer 3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000" style={style}>
            <line style={cls1} className="cls-1" x1="45.85" y1="239.67" x2="45.85" y2="626.81"/>
            <path style={cls2} className="cls-2" d="M368.77,238c105.71,0,155.94,55.88,179.47,102.75,25,49.86,25.31,99.17,25.31,101.25,0,.41.41,45.48,22.69,89.44,29,57.19,80.44,86.19,153,86.19,96.94,0,175.8-78.87,175.8-175.8q0-2.21-.06-4.41c-2.35,94.9-80.28,171.39-175.74,171.39-72.51,0-124-29-153-86.19-22.28-44-22.69-89-22.69-89.45,0-2.07-.28-51.38-25.31-101.24-23.53-46.87-73.76-102.75-179.47-102.75-54.42,0-105.81,21.42-144.7,60.32s-60.32,90.28-60.32,144.7c0,1.47,0,2.94.06,4.41,1.12-52.78,22.42-102.45,60.26-140.29C263,259.46,314.35,238,368.77,238Z"/>
            <path style={cls3} className="cls-3" d="M893.9,297.17c-38.9-38.9-90.29-60.31-144.71-60.31a204.7,204.7,0,0,0-109.8,31.88A14.61,14.61,0,0,0,655,293.42a175.5,175.5,0,0,1,94.15-27.35c95.46,0,173.39,76.48,175.74,171.39q.06,2.21.06,4.41c0,96.93-78.86,175.8-175.8,175.8-72.51,0-124-29-153-86.19-22.28-44-22.69-89-22.69-89.44,0-2.08-.28-51.39-25.31-101.25C524.71,293.92,474.48,238,368.77,238c-54.42,0-105.81,21.42-144.7,60.32-37.84,37.84-59.14,87.51-60.26,140.29,1.12,52.78,22.42,102.45,60.26,140.29,38.89,38.89,90.28,60.31,144.7,60.31a204.47,204.47,0,0,0,112.44-33.58,14.61,14.61,0,1,0-16-24.44A175.3,175.3,0,0,1,368.77,610C273.31,610,195.38,533.55,193,438.65q-.06-2.2-.06-4.41c0-96.94,78.87-175.8,175.8-175.8,72.52,0,124,28.86,152.92,85.77,22.24,43.73,22.64,88.57,22.64,89,0,2.09.3,51.59,25.34,101.66,23.55,47.08,73.8,103.19,179.52,103.19,54.42,0,105.81-21.42,144.71-60.31,37.84-37.84,59.13-87.51,60.25-140.29C953,384.68,931.74,335,893.9,297.17Z"/>
            <path style={cls3} className="cls-3" d="M497.58,764.41v-95c0-4.2,2.17-6.37,6.52-6.37,4.19,0,6.21,2.17,6.21,6.37v34.93c5.43-4.19,11-5.75,17.7-5.75a30.22,30.22,0,0,1,30,30.12v35.71c0,3.57-2.17,6.37-6.36,6.37s-6.52-2.8-6.52-6.37V728.7a17.39,17.39,0,0,0-34.78,0v35.71c0,3.57-2,6.37-6.21,6.37A6.43,6.43,0,0,1,497.58,764.41Z"/>
            <path style={cls3} className="cls-3" d="M624.11,705v59.46a6.3,6.3,0,0,1-6.37,6.37c-4.19,0-6.36-2.49-6.52-6.06-5.43,3.88-11.17,6.06-17.23,6.06a30.28,30.28,0,0,1-30.27-30.12V705a6.33,6.33,0,0,1,6.52-6.37c4.19,0,6.36,2.18,6.36,6.37v35.71a17.31,17.31,0,1,0,34.62,0V705c0-4.19,2.18-6.37,6.52-6.37A6.3,6.3,0,0,1,624.11,705Z"/>
            <path style={cls3} className="cls-3" d="M631.87,764.41V705a6.3,6.3,0,0,1,6.37-6.37c4,0,6.21,2,6.36,5.9a28.7,28.7,0,0,1,17.39-5.9,30.18,30.18,0,0,1,30.27,30.12v35.71a6.44,6.44,0,0,1-12.88,0V728.7a17.39,17.39,0,0,0-34.78,0v35.71a6.21,6.21,0,0,1-6.36,6.37A6.3,6.3,0,0,1,631.87,764.41Z"/>
            <path style={cls3} className="cls-3" d="M697.85,740.66v-12a30.19,30.19,0,0,1,30.28-30.12c6,0,11.8,2.18,17.23,6.06V669.4c0-4.2,2.17-6.37,6.52-6.37,4.19,0,6.37,2.17,6.37,6.37v71.26a30.2,30.2,0,0,1-60.4,0Zm12.89,0a17.31,17.31,0,1,0,34.62,0v-12a17.31,17.31,0,0,0-34.62,0Z"/>
            <path style={cls3} className="cls-3" d="M816.15,714.73l.16-.16c-2.95,3.73-6.83,3.26-9.32,1.25a16.62,16.62,0,0,0-11-4A17.3,17.3,0,0,0,778.74,729v35.4a6.21,6.21,0,0,1-6.37,6.37c-4.34,0-6.52-2.18-6.52-6.37V705.26c0-4.19,2.18-6.37,6.52-6.37a6.38,6.38,0,0,1,6.37,5.44,30,30,0,0,1,36.48,1.55A6.83,6.83,0,0,1,816.15,714.73Z"/>
            <path style={cls3} className="cls-3" d="M825,752.46a33.13,33.13,0,0,1-2.17-11.8v-12a29.69,29.69,0,0,1,18.47-27.63h-.15a27.69,27.69,0,0,1,11.8-2.49,30,30,0,0,1,27.63,18.48,25.62,25.62,0,0,1,2.48,11.64,6.86,6.86,0,0,1-1.86,4.66,7.21,7.21,0,0,1-4.5,1.86h-41v5.44c0,7.29,4.19,13,10.56,16A15.6,15.6,0,0,0,853,758a17.5,17.5,0,0,0,12.26-5.27,18.62,18.62,0,0,0,3.73-5.44c1.24-2.48,1.86-4,6-4,3.57,0,6.37,1.86,6.37,6.05a4.82,4.82,0,0,1-.62,2.33,31.56,31.56,0,0,1-6.52,10.4,29.52,29.52,0,0,1-21.27,8.7A30.64,30.64,0,0,1,825,752.46Zm12.58-31.21-.62,1.24h32c-3-6.67-9-11-16-11C846.27,711.47,840.68,715.2,837.58,721.25Z"/>
            <path style={cls3} className="cls-3" d="M888.19,740.66v-12a30.18,30.18,0,0,1,30.27-30.12c6.06,0,11.8,2.18,17.23,6.06V669.4c0-4.2,2.18-6.37,6.52-6.37,4.19,0,6.37,2.17,6.37,6.37v71.26a30.2,30.2,0,0,1-60.39,0Zm12.88,0a17.31,17.31,0,1,0,34.62,0v-12a17.31,17.31,0,0,0-34.62,0Z"/>
        </svg>
    )
}

const HuLogo1: React.FC<Props> = (props: Props) => {
    const style1: React.CSSProperties = {
        fill:'none',
        stroke: `${props.color ? props.color : '#333'}`,
        strokeWidth:5.29167,
        strokeLinecap:'round',
        strokeLinejoin:'round',
        strokeMiterlimit:4,
        strokeDasharray:'none'
    }

    const style2: React.CSSProperties = {
        fill:'none',
        stroke: `${props.color ? props.color : '#333'}`,
        strokeWidth:5.29167,
        strokeLinecap:'round',
        strokeLinejoin:'round',
        strokeMiterlimit:4,
        strokeDasharray:'none'
    }

    const style3: React.CSSProperties = {
        fill:'none',
        stroke: `${props.color ? props.color : '#333'}`,
        strokeWidth:5.29167,
        strokeLinecap:'round',
        strokeLinejoin:'round',
        strokeMiterlimit:4,
        strokeDasharray:'none'
    }

    return (
        <svg
            width={props.width ? props.width : "100px"}
            height={props.height ? props.height : "100px"}
            viewBox="0 0 133.80357 133.80357">
            <g
               transform="translate(-38.098215,-81.598216)">
              <path
                 style={style1}
                 d="M 169.25595,148.5 A 64.255951,64.255951 0 0 1 105,212.75595 64.255951,64.255951 0 0 1 40.74405,148.5 64.255951,64.255951 0 0 1 105,84.244051 64.255951,64.255951 0 0 1 169.25595,148.5 Z">                   
              </path>
              <path
                 style={style2}
                 d="m 157.16072,163.61905 a 40.82143,40.82143 0 0 1 -40.82143,40.82143 40.82143,40.82143 0 0 1 -40.821432,-40.82143 40.82143,40.82143 0 0 1 40.821432,-40.82143 40.82143,40.82143 0 0 1 40.82143,40.82143 z" />
              <path
                 style={style3}
                 d="M 133.72619,154.54762 A 25.702381,25.702381 0 0 1 108.0238,180.25 25.702381,25.702381 0 0 1 82.321426,154.54762 25.702381,25.702381 0 0 1 108.0238,128.84524 a 25.702381,25.702381 0 0 1 25.70239,25.70238 z">
              </path>
            </g>
        </svg>
    )
}

const HuLogoSpinner: React.FC<Props> = (props: Props) => {
    const style1: React.CSSProperties = {
        fill:'none',
        stroke: `${props.color ? props.color : '#333'}`,
        strokeWidth:5.29167,
        strokeLinecap:'round',
        strokeLinejoin:'round',
        strokeMiterlimit:4,
        strokeDasharray:'none'
    }

    const style2: React.CSSProperties = {
        fill:'none',
        stroke: `${props.color ? props.color : '#333'}`,
        strokeWidth:5.29167,
        strokeLinecap:'round',
        strokeLinejoin:'round',
        strokeMiterlimit:4,
        strokeDasharray:'none'
    }

    const style3: React.CSSProperties = {
        fill:'none',
        stroke: `${props.color ? props.color : '#333'}`,
        strokeWidth:5.29167,
        strokeLinecap:'round',
        strokeLinejoin:'round',
        strokeMiterlimit:4,
        strokeDasharray:'none'
    }

    return (
        <svg
            width={props.width ? props.width : "100px"}
            height={props.height ? props.height : "100px"}
            viewBox="0 0 150 150" style={props.style}>
            <g
               transform="translate(-38.098215,-81.598216)">
              <path
                 style={style1}
                 d="M 169.25595,148.5 A 64.255951,64.255951 0 0 1 105,212.75595 64.255951,64.255951 0 0 1 40.74405,148.5 64.255951,64.255951 0 0 1 105,84.244051 64.255951,64.255951 0 0 1 169.25595,148.5 Z">
                <animateTransform 
                        attributeName="transform" 
                        attributeType="XML" 
                        type="rotate"
                        dur="1.5s" 
                        from="360 105 150"
                        to="0 105 150" 
                        additive="sum"
                        repeatCount="indefinite" />                    
              </path>
              <path
                 style={style2}
                 d="m 157.16072,163.61905 a 40.82143,40.82143 0 0 1 -40.82143,40.82143 40.82143,40.82143 0 0 1 -40.821432,-40.82143 40.82143,40.82143 0 0 1 40.821432,-40.82143 40.82143,40.82143 0 0 1 40.82143,40.82143 z" >
                     <animateTransform 
                        attributeName="transform" 
                        attributeType="XML" 
                        type="rotate"
                        dur="1.5s" 
                        from="360 105 150"
                        to="0 105 150" 
                        additive="sum"
                        repeatCount="indefinite" />
              </path>
              <path
                 style={style3}
                 d="M 133.72619,154.54762 A 25.702381,25.702381 0 0 1 108.0238,180.25 25.702381,25.702381 0 0 1 82.321426,154.54762 25.702381,25.702381 0 0 1 108.0238,128.84524 a 25.702381,25.702381 0 0 1 25.70239,25.70238 z">
                     <animateTransform 
                        attributeName="transform" 
                        attributeType="XML" 
                        type="rotate"
                        dur="1.5s" 
                        from="360 105 150"
                        to="0 105 150" 
                        additive="sum"
                        repeatCount="indefinite" />
              </path>
            </g>
        </svg>
    )
}

const HuArrow: React.FC<Props> = (props: Props) => {
    const style: React.CSSProperties = {
        fill: props.color ? props.color : "#000000",
        stroke: props.color ? props.color : "#000000",
        strokeWidth:0.264584,
        strokeLinecap:"round",
        strokeLinejoin:"round",
        strokeMiterlimit:4,
        strokeDasharray:"none"
    }

    return(
         <svg className={props.className}  width={props.width ? props.width : "50"} height={props.height ? props.height : "50"} viewBox="0 0 13.229166 13.229167">
            <path style={style} d="M 6.6145829,2.3129704 13.183342,0.09378244 6.6145836,13.229876 0.09307221,0.09378184 Z" />
        </svg>
    )

}

const Spinner: React.FC<Props> = (props: Props) => {
    const style = {
        width: props.size ? props.size : "50px",
        height: props.size ? props.size : "50px"
    }
    return(
        <svg style={style} className="spinner" viewBox="0 0 50 50">
            <circle className="path" cx="25" cy="25" r="20" fill="none"></circle>
        </svg>
    )
}

const Sun: React.FC<Props> = (props: Props) => {
    const style : React.CSSProperties = {
        backgroundColor: "transparent",
        width: props.size ? props.size : "45px",
        height: props.size ? props.size : "45px",
        fill: props.darkMode ? "#111111" : "#f9fafb"
    }

    return(
        <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
	        viewBox="0 0 45.16 45.16" style={style}>
<g>
	<g>
		<path d="M22.58,11.269c-6.237,0-11.311,5.075-11.311,11.312s5.074,11.312,11.311,11.312c6.236,0,11.311-5.074,11.311-11.312S28.816,11.269,22.58,11.269z"/>
		<g>
			<g>
				<path d="M22.58,7.944c-1.219,0-2.207-0.988-2.207-2.206V2.207C20.373,0.988,21.361,0,22.58,0c1.219,0,2.207,0.988,2.207,2.207
					v3.531C24.787,6.956,23.798,7.944,22.58,7.944z"/>
			</g>
			<g>
				<path d="M22.58,37.215c-1.219,0-2.207,0.988-2.207,2.207v3.53c0,1.22,0.988,2.208,2.207,2.208c1.219,0,2.207-0.988,2.207-2.208
					v-3.53C24.787,38.203,23.798,37.215,22.58,37.215z"/>
			</g>
			<g>
				<path d="M32.928,12.231c-0.861-0.862-0.861-2.259,0-3.121l2.497-2.497c0.861-0.861,2.259-0.861,3.121,0
					c0.862,0.862,0.862,2.26,0,3.121l-2.497,2.497C35.188,13.093,33.791,13.093,32.928,12.231z"/>
			</g>
			<g>
				<path d="M12.231,32.93c-0.862-0.863-2.259-0.863-3.121,0l-2.497,2.496c-0.861,0.861-0.862,2.26,0,3.121
					c0.862,0.861,2.26,0.861,3.121,0l2.497-2.498C13.093,35.188,13.093,33.79,12.231,32.93z"/>
			</g>
			<g>
				<path d="M37.215,22.58c0-1.219,0.988-2.207,2.207-2.207h3.531c1.219,0,2.207,0.988,2.207,2.207c0,1.219-0.988,2.206-2.207,2.206
					h-3.531C38.203,24.786,37.215,23.799,37.215,22.58z"/>
			</g>
			<g>
				<path d="M7.944,22.58c0-1.219-0.988-2.207-2.207-2.207h-3.53C0.988,20.373,0,21.361,0,22.58c0,1.219,0.988,2.206,2.207,2.206
					h3.531C6.956,24.786,7.944,23.799,7.944,22.58z"/>
			</g>
			<g>
				<path d="M32.928,32.93c0.862-0.861,2.26-0.861,3.121,0l2.497,2.497c0.862,0.86,0.862,2.259,0,3.12s-2.259,0.861-3.121,0
					l-2.497-2.497C32.066,35.188,32.066,33.791,32.928,32.93z"/>
			</g>
			<g>
				<path d="M12.231,12.231c0.862-0.862,0.862-2.259,0-3.121L9.734,6.614c-0.862-0.862-2.259-0.862-3.121,0
					c-0.862,0.861-0.862,2.259,0,3.12l2.497,2.497C9.972,13.094,11.369,13.094,12.231,12.231z"/>
			</g>
		</g>
	</g>
</g>
</svg>
    )
}

const Moon: React.FC<Props> = (props: Props) => {
    const style : React.CSSProperties ={
        backgroundColor: "transparent",
        width: props.size ? props.size : "45px",
        height: props.size ? props.size : "45px",
        fill: props.darkMode ? "#111111" : "#f9fafb"
    }

    return(
        <svg version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 312.812 312.812" style={style}>
            <g>
            	<g>
            		<path d="M305.2,178.159c-3.2-0.8-6.4,0-9.2,2c-10.4,8.8-22.4,16-35.6,20.8c-12.4,4.8-26,7.2-40.4,7.2c-32.4,0-62-13.2-83.2-34.4
            			c-21.2-21.2-34.4-50.8-34.4-83.2c0-13.6,2.4-26.8,6.4-38.8c4.4-12.8,10.8-24.4,19.2-34.4c3.6-4.4,2.8-10.8-1.6-14.4
            			c-2.8-2-6-2.8-9.2-2c-34,9.2-63.6,29.6-84.8,56.8c-20.4,26.8-32.4,60-32.4,96c0,43.6,17.6,83.2,46.4,112s68,46.4,112,46.4
            			c36.8,0,70.8-12.8,98-34c27.6-21.6,47.6-52.4,56-87.6C314,184.959,310.8,179.359,305.2,178.159z"/>
            	</g>
            </g>
        </svg>
    )
}

const ImmunefiLogo: React.FC<Props> = (props: Props) => {
    const style: React.CSSProperties ={
        fill: "#687785"
    }

    return(props.isMobile ? (
        <svg width="36" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path style={style} fillRule="evenodd" clipRule="evenodd" d="M6.50824 11.0549L14.5718 19.2632L22.5493 11.1425L29.0902 17.8008L21.4906 25.5369L19.5355 23.5998L25.2322 17.8008L22.5493 15.0697L14.5718 23.1904L6.50824 14.9821L3.85799 17.6799L9.64133 23.5671L7.68629 25.5042L0 17.6799L6.50824 11.0549Z"/>
            <path style={style} fillRule="evenodd" clipRule="evenodd" d="M22.582 14.982L14.5184 6.77364L6.54091 14.8943L2.28882e-05 8.23604L7.59967 0.499977L9.55471 2.43708L3.85801 8.23604L6.54091 10.9671L14.5184 2.8464L22.582 11.0547L25.2322 8.3569L19.4489 2.46974L21.4039 0.532634L29.0902 8.3569L22.582 14.982Z"/>
            <path style={style} fillRule="evenodd" clipRule="evenodd" d="M13.3147 25.3441L13.3147 20.1725H15.9479L15.9479 25.3441H13.3147Z"/>
            <path style={style} fillRule="evenodd" clipRule="evenodd" d="M13.3147 5.86438L13.3147 0.692822L15.9479 0.692822L15.9479 5.86438L13.3147 5.86438Z"/>
        </svg>
    ) :
        (<svg width="121" height="26" viewBox="0 0 121 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path style={style} fillRule="evenodd" clipRule="evenodd" d="M6.50824 11.0549L14.5718 19.2632L22.5493 11.1425L29.0902 17.8008L21.4906 25.5369L19.5355 23.5998L25.2322 17.8008L22.5493 15.0697L14.5718 23.1904L6.50824 14.9821L3.85799 17.6799L9.64133 23.5671L7.68629 25.5042L0 17.6799L6.50824 11.0549Z"/>
            <path style={style} fillRule="evenodd" clipRule="evenodd" d="M22.582 14.982L14.5184 6.77364L6.54091 14.8943L2.28882e-05 8.23604L7.59967 0.499977L9.55471 2.43708L3.85801 8.23604L6.54091 10.9671L14.5184 2.8464L22.582 11.0547L25.2322 8.3569L19.4489 2.46974L21.4039 0.532634L29.0902 8.3569L22.582 14.982Z"/>
            <path style={style} fillRule="evenodd" clipRule="evenodd" d="M13.3147 25.3441L13.3147 20.1725H15.9479L15.9479 25.3441H13.3147Z"/>
            <path style={style} fillRule="evenodd" clipRule="evenodd" d="M13.3147 5.86438L13.3147 0.692822L15.9479 0.692822L15.9479 5.86438L13.3147 5.86438Z"/>
            <path style={style} d="M41.7141 6.60562H39.0902V19.8166H41.7141V6.60562Z"/>
            <path style={style} d="M55.0236 10.0919C53.8309 10.0919 52.6933 10.6056 52.1245 11.7249C51.5373 10.6056 50.4364 10.0919 49.152 10.0919C47.9961 10.0919 47.1153 10.5322 46.6566 11.3212L46.3814 10.2753H43.9961V19.8166H46.5649V14.4772C46.5649 13.0643 47.2988 12.3854 48.3814 12.3854C49.4089 12.3854 50.1061 13.0276 50.1061 14.5873V19.8166H52.5832V14.5322C52.6199 13.046 53.3906 12.3854 54.3997 12.3854C55.4456 12.3854 56.1245 13.0276 56.1245 14.4588V19.835H58.7117V13.9451C58.7117 11.3029 56.9318 10.0919 55.0236 10.0919Z"/>
            <path style={style} d="M71.7774 10.0919C70.5848 10.0919 69.4472 10.6056 68.8784 11.7249C68.2912 10.6056 67.1903 10.0919 65.9059 10.0919C64.7499 10.0919 63.8692 10.5322 63.4105 11.3212L63.1352 10.2753H60.7499V19.8166H63.3187V14.4772C63.3187 13.0643 64.0527 12.3854 65.1352 12.3854C66.1628 12.3854 66.86 13.0276 66.86 14.5873V19.8166H69.3371V14.5322C69.3738 13.046 70.1444 12.3854 71.1536 12.3854C72.1995 12.3854 72.8784 13.0276 72.8784 14.4588V19.835H75.4655V13.9451C75.4655 11.3029 73.6857 10.0919 71.7774 10.0919Z"/>
            <path style={style} d="M83.7607 10.2753V15.5047C83.7607 16.9175 83.1001 17.7616 81.8341 17.7799C80.6231 17.8166 79.8524 17.101 79.8524 15.6148V10.2753H77.412V15.9451C77.412 18.3854 78.8249 20.0001 81.2653 20.0001C82.4029 20.0001 83.2286 19.4864 83.724 18.7708L83.8524 19.8166H86.201V10.2753H83.7607Z"/>
            <path style={style} d="M93.7395 10.0919C92.3083 10.0919 91.3541 10.624 90.8587 11.413L90.7119 10.2753H88.3266V19.8166H90.8954V14.7708C90.8954 13.2295 91.6294 12.2937 92.9872 12.2937C94.2349 12.2937 94.9872 13.101 94.9872 14.679V19.8166H97.5743V14.1469C97.5743 11.7065 96.1798 10.0919 93.7395 10.0919Z"/>
            <path style={style} d="M108.808 14.8992C108.808 11.9818 106.918 10.0919 104.074 10.0919C101.23 10.0919 99.3222 12.0735 99.3222 15.046C99.3222 18.0368 101.23 20.0185 104.093 20.0185C106.496 20.0185 108.313 18.679 108.735 16.6974H106.148C105.854 17.523 105.102 17.9451 104.166 17.9451C102.937 17.9451 101.946 17.1561 101.909 15.7432H108.808V14.8992ZM104.074 12.0919C105.194 12.0919 106.13 12.7341 106.24 14.0552H101.928C102.038 12.7341 102.974 12.0919 104.074 12.0919Z"/>
            <path style={style} d="M109.811 10.2753V12.5139H111.279V19.8166H113.866V12.5139H116.05V10.2753H113.866V9.30287C113.866 8.62397 114.05 8.11021 115.096 8.11021H116.05V6.01846H114.527C112.123 6.01846 111.279 7.19277 111.279 9.04599V10.2753H109.811Z"/>
            <path style={style} d="M117.747 8.80745H120.352L120.389 6.01846H117.783L117.747 8.80745ZM117.783 19.8166H120.352V10.2753H117.783V19.8166Z"/>
        </svg>)
    )
}

const DoneIcon: React.FC<Props> = (props: Props) => {
    return (
        <svg style={props.style} xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 48 48" width={`${props.size ? props.size : "48px"}`} height={`${props.size ? props.size : "48px"}`}>
            <linearGradient id="HoiJCu43QtshzIrYCxOfCa" x1="21.241" x2="3.541" y1="39.241" y2="21.541" gradientUnits="userSpaceOnUse">
                <stop offset=".108" stopColor="#0d7044"/>
                <stop offset=".433" stopColor="#11945a"/>
            </linearGradient>
            <path fill="url(#HoiJCu43QtshzIrYCxOfCa)" d="M16.599,41.42L1.58,26.401c-0.774-0.774-0.774-2.028,0-2.802l4.019-4.019	c0.774-0.774,2.028-0.774,2.802,0L23.42,34.599c0.774,0.774,0.774,2.028,0,2.802l-4.019,4.019	C18.627,42.193,17.373,42.193,16.599,41.42z"/>
            <linearGradient id="HoiJCu43QtshzIrYCxOfCb" x1="-15.77" x2="26.403" y1="43.228" y2="43.228" gradientTransform="rotate(134.999 21.287 38.873)" gradientUnits="userSpaceOnUse">
                <stop offset="0" stopColor="#2ac782"/><stop offset="1" stopColor="#21b876"/>
            </linearGradient>
            <path fill="url(#HoiJCu43QtshzIrYCxOfCb)" d="M12.58,34.599L39.599,7.58c0.774-0.774,2.028-0.774,2.802,0l4.019,4.019	c0.774,0.774,0.774,2.028,0,2.802L19.401,41.42c-0.774,0.774-2.028,0.774-2.802,0l-4.019-4.019	C11.807,36.627,11.807,35.373,12.58,34.599z"/>
        </svg>
    )
}

const MoneyBagIcon: React.FC<Props> = (props: Props) => {
    return(
        <svg style={props.style} width={`${props.size ? props.size : "20px"}`} height={`${props.size ? props.size : "20px"}`} version="1.1" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <path d="m12.965 0.095703c-0.15896-0.0022195-0.31064 0.010049-0.46094 0.033203-0.60119 0.092616-1.1046 0.30989-2.0879 0.47852-0.90316 
                  0.15488-1.516-0.069375-2.2813-0.26367s-1.6944-0.31825-2.8418 0.20117c-0.28042 0.12763-0.37983 0.47603-0.20898 0.73242l1.7734 
                  2.6582c-0.37752 0.35931-1.4713 1.4234-2.7578 3.1387-1.53 2.0401-3.0996 4.7255-3.0996 7.4258 0 2.6502 1.3088 4.1643 3.0703 4.8418s3.9297 
                  0.6582 5.9297 0.6582 4.1682 0.01931 5.9297-0.6582c1.7615-0.67751 3.0703-2.1916 3.0703-4.8418 
                  0-2.7003-1.5696-5.3857-3.0996-7.4258-1.2865-1.7153-2.3803-2.7794-2.7578-3.1387l1.7734-2.6582c0.17291-0.25992 
                  0.068023-0.61298-0.21875-0.73633-0.71859-0.30791-1.2556-0.43865-1.7324-0.44531zm-0.30859 1.0215c0.26653-0.04106 
                  0.67473 0.11912 1.0234 0.21289l-1.4473 2.1699h-4.4648l-1.4629-2.1953c0.57498-0.13768 1.0593-0.12345 1.584 0.0097656 
                  0.70355 0.17862 1.5517 0.47541 2.6953 0.2793 1.0634-0.18237 1.6435-0.41051 2.0723-0.47656zm-4.9492 3.3828h4.5859c0.18738 0.17483 1.4415 
                  1.3555 2.8066 3.1758 1.47 1.9599 2.9004 4.5245 2.9004 6.8242 0 2.3498-0.94122 3.3357-2.4297 3.9082-1.4885 0.57249-3.5703 0.5918-5.5703 
                  0.5918s-4.0818-0.019308-5.5703-0.5918-2.4297-1.5584-2.4297-3.9082c0-2.2997 1.4304-4.8643 2.9004-6.8242 1.3652-1.8202 2.6193-3.0009 2.8066-3.1758zm1.793 
                  4.5v1c-0.8225 0-1.5 0.6775-1.5 1.5s0.6775 1.5 1.5 1.5h1c0.28206 0 0.5 0.21794 0.5 0.5s-0.21794 0.5-0.5 0.5h-1-1.5v1h1.5v1h1v-1c0.8225 0 1.5-0.6775 
                  1.5-1.5s-0.6775-1.5-1.5-1.5h-1c-0.28206 0-0.5-0.21794-0.5-0.5s0.21794-0.5 0.5-0.5h1 1.5v-1h-1.5v-1h-1z" style={{fill: props.color ? props.color : "#222222"}}/>
            </svg>
    )
}

export {HuLogo, HuLogo1, HuLogoSpinner, HuArrow, Spinner, Sun, Moon, ImmunefiLogo, DoneIcon, MoneyBagIcon}